export const tipoStatusAndamentoCriarPedido =
  'TIPO_STATUS_ANDAMENTO_CRIAR_PEDIDO';
export const tipoStatusAndamentoDetalhes = 'TIPO_STATUS_ANDAMENTO_DETALHES';
export const tipoStatusAndamentoAprovar = 'TIPO_STATUS_ANDAMENTO_APROVAR';
export const tipoStatusAndamentoAprovarVolta =
  'TIPO_STATUS_ANDAMENTO_APROVAR_VOLTA';
